import classNames from "classnames";
import styles from "./Card.module.scss";
import { forwardRef } from "react";

const Card = forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
  }
>(function Card({ children, className, onClick }, ref) {
  if (onClick) {
    return (
      <button
        className={classNames(styles.button, styles.card, className)}
        onClick={onClick}
        type="button"
      >
        {children}
      </button>
    );
  }
  return (
    <div ref={ref} className={classNames(styles.card, className)}>
      {children}
    </div>
  );
});

export default Card;
